import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  collection,
  getDoc,
  getDocs,
  doc,
  query,
  orderBy,
  onSnapshot,
  deleteDoc,
  setDoc,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { db, storage } from "../../firebase";
import { useHistory } from "react-router-dom";
import MyPopover from "../Popover";
import { useSnackbar } from "notistack";
import { deleteObject, ref } from "firebase/storage";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Select,
  Switch,
} from "@mui/material";
import { sFeed, sFeedMgt, sOnOff, sOperate, sSort } from "../Strings";
import AddFeedModal from "./AddFeedModal";

export default function FeedList() {
  const [category, setCat] = React.useState("");
  const [openModal, setOpenModal] = React.useState(false);
  const [feed, setFeed] = useState([]);
  const [row, setRow] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const feedRef = query(collection(db, sFeed), orderBy(sSort));

  // const [productRef, setProductRef] = useState(productRef1);
  // const productRef = query(collection(db, sProducts), orderBy("name"));

  useEffect(() => {
    getDocs(feedRef).then((snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setFeed(data);
    });
  }, []);

  const history = useHistory();

  const handleClick = (val) => {
    setRow(val);
    setOpenModal(true);
  };

  function getCat(id) {
    const itemRef = doc(db, "category", id);
    getDoc(itemRef).then((snapshot) => {
      // console.log(snapshot.data().name);
      setCat(snapshot.data().name);
    });

    return category;
  }

  function Row(props) {
    const { row } = props; // get row data

    // action button options
    const options = [
      {
        name: "Edit",
        status: 2,
      },
      {
        name: "Delete",
        status: 1,
      },
    ];
    // create product document ref
    const feedRef = doc(db, sFeed, row.id);

    const deleteImages = (urls) => {
      // delete each image in array
      for (const imageUrl of urls) {
        const imageRef = ref(storage, imageUrl);
        const del = deleteObject(imageRef);
      }
      return deleteProduct();
    };

    const deleteProduct = () => {
      // delete document
      deleteDoc(feedRef).then(() => {
        // remove object from product list
        var array = feed.filter((v) => v.id !== row.id);
        setFeed(array);

        console.log("Deleted");
        enqueueSnackbar("Product Deleted!", { variant: "success" });
      });
    };

    function UpdateStatus(id) {
      if (id === 1) {
        deleteImages(row.imageURL);
      } else if (id === 2) {
        handleClick(row);
      }
    }

    function updateProductStatus(checked) {
      let i = 1;
      if (checked) i = 0;
      setDoc(feedRef, { status: i }, { merge: true }).then(() => {
        enqueueSnackbar("State Updated!", { variant: "success" });
        console.log("Document updated ", row.id);
      });
    }

    function ControlledSwitches() {
      const [checked, setChecked] = React.useState(true);

      const handleChange = (event) => {
        setChecked(event.target.checked);
        // pass state
        updateProductStatus(event.target.checked);
      };

      useEffect(() => {
        // if product status is hidden
        if (row.status === 1) setChecked(false);
      }, []);

      return (
        <Switch
          checked={checked}
          onChange={handleChange}
          inputProps={{ "aria-label": "controlled" }}
        />
      );
    }

    return (
      <TableRow
        hover
        sx={{
          "&:last-child td, &:last-child th": { border: 0 },
          cursor: "pointer",
        }}
      >
        <TableCell component="th" scope="row" onClick={() => handleClick(row)}>
          {row.name}
        </TableCell>
        <TableCell align="right">{row.sub}</TableCell>

        <TableCell align="right">{row.sort}</TableCell>

        <TableCell align="right">
          <ControlledSwitches />
        </TableCell>
        <TableCell align="right">
          <MyPopover onClick={UpdateStatus} options={options} />
        </TableCell>
      </TableRow>
    );
  }

  return (
    <div>
      <h2>{sFeedMgt}</h2>
      <AddFeedModal open={openModal} setOpen={setOpenModal} row={row} />

      <TableContainer
        sx={{ mt: 3, mb: 5, overflowX: "initial" }}
        component={Paper}
      >
        <Table sx={{ minWidth: 650 }} stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell align="right">Sub Title</TableCell>
              <TableCell align="right">Sort</TableCell>
              <TableCell align="right">{sOnOff}</TableCell>
              <TableCell align="right">{sOperate}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {feed.map((row, key) => (
              <Row row={row} key={key} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
